const clientPaymentsDt              = require('./clientPayments-dt')
const clientPaymentsMenu            = require('./clientPayments-menu')
const clientPaymentsPage            = require('./clientPayments-page')
const clientPaymentsSnack           = require('./clientPayments-snack')
const clientPaymentsReport          = require('./clientPayments-report')

export function start(detail){  //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      dt:              { start: (detail)=>{  clientPaymentsDt. start(detail)              }},
      menu:            { start: (detail)=>{  clientPaymentsMenu.start(detail)             }},
      page:            { start: (detail)=>{  clientPaymentsPage.start(detail)             }},
      snack:           { start: (detail)=>{  clientPaymentsSnack.start(detail)            }},
      report:          { start: (detail)=>{  clientPaymentsReport.start(detail)           }},

}